"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _find = _interopRequireDefault(require("lodash/find"));
var _constant = require("../constant");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var getDurationName = function getDurationName(durationId, type) {
  if (type === _constant.opportunityTypes.EVENT) {
    return type;
  }
  if (!durationId) {
    return '';
  }
  var duration = (0, _find.default)(_constant.durationOptions, function (option) {
    return option.id === durationId;
  });
  if (type === _constant.opportunityTypes.JOB) {
    return duration.name;
  }
  if (durationId === _constant.opportunityDuration.FULL_TIME) {
    return "Internship (FT)";
  }
  return "Internship (PT)";
};
var _default = getDurationName;
exports.default = _default;